export const ui = {
// ── SIDEBAR NAVIGATION ───────────────────────────────────────

'nav_chapter_health_intelligence': 'HEALTH INTELLIGENCE',
'nav_chapter_health_pillars': 'HEALTH PILLARS',
'nav_chapter_test_results': 'TEST RESULTS',
'nav_chapter_utilities_apps': 'HEALTH UTILITIES',
'nav_chapter_account': 'ACCOUNT',

'nav_welcome': 'Welcome',
'welcome_vision': 'Based on standardized laboratory tests and in collaboration with science, preventive medicine specialists, and molecular biologists, speak23 transforms your health data into actionable, rapidly implementable, and personalized recommendations – for more healthy years.',
'welcome_pattern_intro': 'speak23 software checks not only the obvious – markers within normal range. The software also looks for patterns that routine reports often hide:',
'welcome_pattern_item1': 'Early metabolic drift – years before a value turns red',
'welcome_pattern_item2': 'Low-grade inflammation quietly accelerating aging',
'welcome_pattern_item3': 'Immune Aging – which almost never appears on general checkups',
'welcome_tour_header': 'Not yet familiar with the speak23 software?',
'welcome_tour_prompt': 'Start a short tour and get to know the most important areas of the application. We guide you step by step through what you\'ll find where — and what your values mean for your health.',
'welcome_tour_intro': 'We guide you step by step through what you\'ll find where — and what your values mean for your health.',
'welcome_aging_header': 'Don\'t Accept Rapid Aging',
'welcome_aging_text': 'The foundation for healthy longevity is sleep, nutrition, and exercise. Regular strength training helps counteract the loss of muscle mass with age. If you integrate some of these principles into your lifestyle, the benefit of the speak23 software is greatest. Your "biological age" is a good point of orientation for you.',
'welcome_aging_text2': 'The speak23 software shows you whether you can optimize your health regarding vitamins or minerals through dietary adjustments or supplementation (an optimal Omega-3 Index is a good example of this).',
'welcome_section_header': 'What awaits you here:',
'welcome_section_subheader': 'In the top left next to the logo you will find the button to open and close the navigation menu for the application. This navigation bar is your most important guide to all functions of the application. It is divided into 4 sections:',
'welcome_box1_title': 'Control your Health',
'welcome_box1_item1': 'speak23 analyses your health based on 4 pillars: Metabolism, Immune System, Organs, and (Micro-)Nutrients. For each of these 4 fundamental health pillars you will find a dedicated page with your evaluations in this section.',
'welcome_box1_item2': 'In the Cockpit you will find a summary of all evaluations, personalized recommendations, and a suggested agenda for your next doctor\'s appointment.',
'welcome_box2_title': 'Your Test Results',
'welcome_box2_item1': 'This section contains your results from the lab visit. All information related to the lab visit is displayed here, with results organized by selected tests. The Core Health blood test is always shown first, followed by any optional add-on packages. You can immediately see how many markers in each package require attention.',
'welcome_box2_item2': 'If you have ordered the "Biological Age" add-on, you will find a dedicated analysis page for it here.',
'welcome_box2_item3': 'If you have ordered the hormone package or the ovarian reserve package as a woman, there is a dedicated page with in-depth analysis for these (women only).',
'welcome_box2_item4': 'Your detailed gut microbiome report is the last menu item in this section, provided you have ordered this report.',
'welcome_box3_title': 'Further Applications for your Health',
'welcome_box3_item1': 'The Body & Blood Pressure section allows you to document and track your body weight, waist circumference, BMI (Body Mass Index), and blood pressure.',
'welcome_box3_item2': 'The Cycle Tracker for women is used, among other things, for the analysis of blood markers – especially in areas such as hormones.',
'welcome_box3_item3': 'In the Medication List you document your daily medication intake, which also helps to correctly interpret and evaluate blood values.',
'welcome_box3_item4': 'In the "Historical Lab Reports" section you can upload additional documents you have in paper form as a PDF or photo. This way all your important health documents are always in one place.',
'welcome_box4_title': 'Administration',
'welcome_box4_item1': 'In the "Lab Visits" section you can manage your upcoming lab visits. For each additional lab visit you can add optional packages alongside the Core Health blood test.',
'welcome_box4_item2': 'Under "Subscription" you manage your subscription and can also change your payment method.',
'welcome_box4_item3': 'The "Add-On Purchases" section shows an overview of all optional packages you have selected so far.',
'welcome_box4_item4': 'The "Questionnaire Answers" menu item shows your responses to questionnaires you have completed so far.',
'welcome_box4_item5': 'In "Personal Data" you can always keep your information up to date. It is especially important for women to select and maintain the correct profile here for high-quality data analysis.',
'welcome_box4_item6': 'Change your password frequently and regularly – this menu item is here for exactly that purpose.',
'welcome_privacy_header': 'Privacy and Security',
'welcome_help_header': 'Where can I get help and support?',
'welcome_help_text': 'If you have any questions, simply send an email to office@speak23.com. We will be happy to answer them or give you a personal callback if you prefer. We will shortly be adding another menu item in the Administration section covering help and learning around health.',
'welcome_privacy_text': 'Your information is protected using industry-standard security measures. Only authorized users can access your data according to your permissions and applicable healthcare regulations.',
'nav_health_summary_cockpit': 'Health Cockpit',
'nav_12_mechanisms': '12 Mechanisms',
'nav_biological_age': 'Biological Age',
'nav_omega_details': 'Omega Fatty Acids',
'nav_metabolic_health_cockpit': 'Pillar 1 - Metabolism',
'nav_immune_health_cockpit': 'Pillar 2 - Immune System',
'nav_organ_health_cockpit': 'Pillar 3 - Organ Health',
'nav_micronutrients_health_cockpit': 'Pillar 4 - Micronutrients',
'nav_core_health': 'Core Health Bloodtest',
'nav_arteriosclerosis_prevention': 'Atherosclerosis Prevention',
'nav_marker_omega_lifestyle': 'Omega-3 Index - Fatty Acids',
'nav_hormones_balance': 'Hormones - Female',
'nav_bones_health': 'Bones Health',
'nav_vitamins_nutrients': 'Vitamins & Nutrients',
'nav_thyroid_health': 'Thyroid Health',
'nav_female_fertility_amh': 'Ovarian Reserve - Female',
'nav_female_fertility_amh2': 'Ovarian Reserve - Female',
'nav_male_prostate_health_psa': 'Prostate Cancer Prevention',
'nav_stool_cancer_test_fob': 'Stool Cancer Test - FOB',
'nav_bloodtests': 'Lab Test Results',
'nav_stooltests': 'Stool Tests',
'nav_gut_microbiome_report': 'Gut Microbiome Report',
'nav_health_essentials': 'Body & Blood Pressure',
'nav_female_cycle_tracker': 'Female Cycle Tracker',
'nav_your_medication_list': 'Medication List',
'nav_kit_activation_stool_sample': 'Kit Activation - Stool Sample',
'nav_your_labvisits': 'Labvisits',
'nav_your_subscription': 'Subscription',
'nav_your_addon_purchases': 'Add-On Purchases',
'nav_your_questionnaire_responses': 'Questionnaire Responses',
'nav_feedback': 'Feedback',
'nav_your_personal_data': 'Personal Data',
'nav_your_change_password': 'Change Password',

'nav_hormones_balance2': 'Hormones',
'av_female_fertility_amh2': 'Ovarian Reserve - Female',

// ── HORMONE CYCLE CHART ───────────────────────────────────────
'hcc_title':               'Hormones and Cycle',
'hcc_day':                 'Day',
'hcc_select_marker':       'Select the marker:',
'hcc_latest_result':       'Latest result',
'hcc_no_data':             'No measurement data available — reference curves only',
'hcc_role_E2':             'Mood & Energy',
'hcc_role_P4':             'Calm & Sleep',
'hcc_role_LH':             'Ovulation Trigger',
'hcc_role_FSH':            'Ovarian Signal',
'hcc_insight_E2_NORMAL':   'Your oestrogen is supporting healthy cycle rhythms.',
'hcc_insight_E2_LOW':      "Lower E2 may contribute to 'dry' days or lower mood.",
'hcc_insight_E2_HIGH':     'Elevated E2 can lead to breast tenderness or heavier periods.',
'hcc_insight_P4_NORMAL':   'Your levels are well-balanced for this stage.',
'hcc_insight_P4_LOW':      'Low P4 in the Luteal phase can cause spotting or PMS anxiety.',
'hcc_insight_P4_HIGH':     'Strong progesterone levels usually mean a healthy ovulation occurred.',
'hcc_insight_FSH_NORMAL':  'Ovarian communication is within the typical range.',
'hcc_insight_FSH_LOW':     'Normal for your stage; the signal between brain and ovaries is quiet.',
'hcc_insight_FSH_HIGH':    'Rising FSH suggests your ovaries need a louder signal — a key marker of the transition.',
'hcc_insight_LH_NORMAL':   'Your pituitary signal is behaving as expected.',
'hcc_insight_LH_LOW':      'Typical outside of your narrow ovulation window.',
'hcc_insight_LH_HIGH':     'High LH can interfere with egg quality or signal a hormonal imbalance.',

// ── MENOPAUSE HORMONE CHART ───────────────────────────────────
'mhc_title':               'Hormones and Perimenopause / Menopause',
'mhc_select_marker':       'Select the marker:',
'mhc_latest_result':       'Latest result',
'mhc_what_means':          'What this means for you',
'mhc_phase_peri':          'Perimenopause',
'mhc_phase_menopause':     'Menopause',
'mhc_phase_postmeno':      'Postmenopause',
'mhc_legend_range':        'Reference range',
'mhc_legend_mean':         'Typical mean',
'mhc_legend_hrt':          'With HRT',
'mhc_hrt_label':           'WITH HRT',
'mhc_role_fsh':            'Ovarian Signal',
'mhc_role_lh':             'Ovulation Trigger',
'mhc_role_e2':             'Mood & Energy',
'mhc_role_p4':             'Calm & Sleep',
'mhc_status_expected':     'EXPECTED',
'mhc_status_therapeutic':  'THERAPEUTIC',
// fsh
'mhc_fsh_EXPECTED_title':  'Your FSH confirms postmenopausal status',
'mhc_fsh_EXPECTED_text':   'An FSH in the postmenopausal range is a normal, permanent feature of this phase. Your pituitary is signalling strongly because the ovaries no longer respond — this is expected and requires no treatment. Standard HRT does not meaningfully suppress FSH.',
'mhc_fsh_HIGH_title':      'Your FSH is elevated — consistent with menopause',
'mhc_fsh_HIGH_text':       'A high FSH reflects your ovaries no longer producing oestrogen. This is expected in postmenopause. If you are not yet on HRT, discuss with your clinician whether supplementation is appropriate for you.',
'mhc_fsh_NORMAL_title':    'Your FSH is within range',
'mhc_fsh_NORMAL_text':     'Your FSH is within the reference range for your current phase. This is a reassuring signal that hormone communication is functioning as expected.',
'mhc_fsh_LOW_title':       'Your FSH is lower than expected',
'mhc_fsh_LOW_text':        'A low FSH in postmenopause may reflect HRT suppression or another hormonal influence. Discuss with your clinician if this is unexpected given your current treatment.',
// lh
'mhc_lh_EXPECTED_title':   'Your LH is in the expected postmenopausal range',
'mhc_lh_EXPECTED_text':    "Elevated LH is a permanent, expected feature of postmenopause. It reflects the absence of ovarian feedback — not a pituitary problem. HRT has minimal effect on LH, so this level is normal even on treatment.",
'mhc_lh_HIGH_title':       'Your LH is elevated',
'mhc_lh_HIGH_text':        "Elevated LH in postmenopause is expected and does not require treatment. It reflects the body's ongoing — but unanswered — signal to the ovaries.",
'mhc_lh_NORMAL_title':     'Your LH is within range',
'mhc_lh_NORMAL_text':      'Your LH is within the reference range for your phase, reflecting stable pituitary signalling.',
'mhc_lh_LOW_title':        'Your LH is lower than expected',
'mhc_lh_LOW_text':         'A low LH in postmenopause is unusual and may be worth discussing with your clinician, particularly if you are on medications that could influence pituitary function.',
// e2
'mhc_e2_THERAPEUTIC_title': 'Your oestrogen is in the therapeutic range',
'mhc_e2_THERAPEUTIC_text':  'Your E2 level is consistent with effective HRT absorption. This range supports bone density, cardiovascular health, mood and cognitive function. Maintaining oestrogen at this level is one of the key goals of HRT in postmenopause.',
'mhc_e2_LOW_title':         'Your oestrogen is below the therapeutic target',
'mhc_e2_LOW_text':          'A low E2 on HRT may mean your current dose or delivery method is not being absorbed effectively. Common causes include patch placement, skin issues, or body composition. Discuss a dose review with your clinician — symptoms like hot flashes or poor sleep may be related.',
'mhc_e2_HIGH_title':        'Your oestrogen is above the typical therapeutic range',
'mhc_e2_HIGH_text':         'An E2 above the therapeutic target can occur with higher HRT doses or strong absorption. While not necessarily harmful, your clinician may want to review your dose to ensure it is calibrated to your needs.',
'mhc_e2_NORMAL_title':      'Your oestrogen is in the normal postmenopausal range',
'mhc_e2_NORMAL_text':       'Your E2 is within the typical postmenopausal range. If you are not on HRT, this reflects natural production from peripheral conversion of androgens. If you are experiencing symptoms, discuss with your clinician whether HRT could help.',
// p4
'mhc_p4_LOW_title':         'Your progesterone is below the therapeutic target',
'mhc_p4_LOW_text':          'A P4 below 5 ng/ml on oral progesterone (200mg) suggests the dose may not be fully absorbed. Timing of your blood draw matters — ideally 2–4 hours after taking the dose. Low P4 can affect sleep quality and, if you have a uterus, may not provide adequate endometrial protection. Discuss with your clinician.',
'mhc_p4_THERAPEUTIC_title': 'Your progesterone is in the therapeutic range',
'mhc_p4_THERAPEUTIC_text':  'Your P4 is within the expected range for oral progesterone supplementation. This supports sleep quality, reduces anxiety, and protects the uterine lining if you are also taking oestrogen.',
'mhc_p4_HIGH_title':        'Your progesterone is above the typical range',
'mhc_p4_HIGH_text':         'A P4 above 20 ng/ml on standard oral progesterone is higher than typical and may be related to blood draw timing (measuring the peak shortly after dosing). Discuss with your clinician if this is consistent across multiple readings.',
'mhc_p4_NORMAL_title':      'Your progesterone is within range',
'mhc_p4_NORMAL_text':       'Detectable P4 in postmenopause typically reflects HRT supplementation. Your level is within the expected range for your current phase.',
'mhc_p4_EXPECTED_title':    'Progesterone is near zero — expected without HRT',
'mhc_p4_EXPECTED_text':     "A near-zero P4 is the natural postmenopausal state. If you have a uterus and are taking oestrogen, progesterone supplementation is important to protect the endometrium. Speak with your clinician if this hasn't been discussed.",

// ── Historical Lab Reports ──────────────────────────────────────────────────
'lab_page_hl':              'Health Records - ',
'lab_page_sp':              'Historical Lab Reports',
'lab_nav_item':             'Historical Labreports',
'lab_dash_title':           'Historical Lab Reports',
'lab_dash_subtitle':        'Upload and view your personal lab report documents. Use tags to group different documents together.',
'lab_btn_upload_report':    'Upload Report',
'lab_quota_storage':        'Storage:',
'lab_quota_mb_of':          'MB of',
'lab_quota_mb_used':        'MB used',
'lab_quota_mb_free':        'MB free',
'lab_loading':              'Loading lab reports…',
'lab_empty_title':          'No lab reports yet',
'lab_empty_body':           'Upload your historical lab reports — images (JPEG, PNG) or PDF files',
'lab_empty_btn':            'Upload First Report',
'lab_dia_upload_title':     'Upload Lab Report',
'lab_field_title_label':    'Report Title',
'lab_field_title_ph':       'e.g. Blood Count March 2024',
'lab_field_date_label':     'Report Date',
'lab_field_tags_label':     'Tags',
'lab_field_tags_ph':        'e.g. thyroid surgery',
'lab_drop_idle':            'Drag & drop files here, or click to browse',
'lab_drop_active':          'Drop files here…',
'lab_drop_hint':            'PDF, JPEG, PNG, GIF, WebP · max 10 MB per file · multiple files allowed',
'lab_files_ready':          'file ready to upload',
'lab_files_ready_pl':       'files ready to upload',
'lab_uploading':            'Uploading…',
'lab_err_validation':       'Please fill in a title, date, and select at least one file.',
'lab_err_file_rejected':    'One or more files were not added — only PDF, JPEG, PNG, GIF, WebP up to 10 MB are supported.',
'lab_err_tag_save':         'Failed to save tags.',
'lab_err_tag_no_doc':       'No document selected — please reopen the Edit Tags dialog.',
'lab_err_upload':           'Upload failed.',
'lab_err_load':             'Failed to load lab reports.',
'lab_err_delete':           'Delete failed.',
'lab_btn_cancel':           'Cancel',
'lab_btn_upload_submit':    'Upload',
'lab_btn_view':             'View',
'lab_btn_edit_tags':        'Edit tags',
'lab_btn_tag_save':         'Save',
'lab_tag_edit_title':       'Edit Tags',
'lab_tag_no_options':       'Type to create a new tag',
'lab_filter_all':           'All',
'lab_manage_tags_btn':      'Manage tags',
'lab_manage_tags_title':    'Manage Tags',
'lab_manage_tags_empty':    'No tags yet.',
'lab_tag_rename_btn':       'Rename',
'lab_err_tag_rename':       'Failed to rename tag.',
'lab_err_tag_delete':       'Failed to delete tag.',
'lab_tag_del_title':        'Delete Tag?',
'lab_tag_del_body':         'This tag will be removed from any documents that use it. This action cannot be undone.',
'lab_pdf_pages':            'PDF Pages',
'lab_pdf_doc':              'PDF Document',
'lab_pdf_page_aria':        'PDF page',
'lab_del_title':            'Delete Lab Report?',
'lab_del_body':             'This will permanently delete the report and all its pages. This action cannot be undone.',
'lab_del_btn':              'Delete',
'lab_deleting':             'Deleting…',
'lab_chip_img':             'image',
'lab_chip_img_pl':          'images',
'lab_chip_pdf':             'PDF',
'lab_chip_pdf_pl':          'PDFs',
'lab_chip_page':            'page',
'lab_chip_page_pl':         'pages',
'lab_info_title':           'Upload Tips',
'lab_info_p1':              "Reduce the file size of photos of documents before uploading. If you're photographing documents, scanning them usually creates smaller files than regular photos.",
'lab_info_p2_intro':        'For example, if you are using an Apple iPhone:',
'lab_info_p2_step1':        'Open the Files app.',
'lab_info_p2_step2':        'Tap the ⋯ menu.',
'lab_info_p2_step3':        'Select Scan Documents.',
'lab_info_p2_step4':        'Scan the pages and save them as a PDF.',
'lab_info_p3':              'PDF scans are often much smaller and easier to upload than full-resolution photos.',
'lab_info_p4':              'Try to reduce Camera Resolution for future document photos. Also check the current file size before uploading.',

"vitals_body_shape":        "Body Shape & BMI",
"vitals_markers":           "MARKERS",
"vitals_blood_pressure":    "Blood Pressure",
"vitals_bp_ref":            "Ref: ~120 / 80 mmHg",
"vitals_height":              "Height",
"vitals_weight":              "Weight",
"vitals_bmi":                 "BMI",
"vitals_waist":               "Waist",
"vitals_weight_ref":          "Based on BMI",
"vitals_bmi_ref":             "normal: 18.5 – 25",
"vitals_waist_ref_m":         "reference < 102 cm",
"vitals_waist_ref_f":         "reference < 88 cm",
"vitals_whtr":                "Waist-to-Height Ratio",
"vitals_whtr_ref":            "reference < 0.5",
"vitals_whtr_info_title":     "Waist-to-Height Ratio",
"vitals_whtr_info_body":      "The waist-to-height ratio is an anthropometric measure that indicates the amount and distribution of body fat. The higher its value, the greater the cardiovascular risk. In a study with around 11,000 participants, the WHtR proved to be a better prognostic parameter for cardiovascular diseases such as heart attack or stroke than the body mass index (BMI). The critical threshold for people under 40 years of age is a WHtR of 0.5.",
"vitals_set_height":          "Set Height",
"vitals_height_dialog_title": "Update Height",
"vitals_height_dialog_body":  "Your height is needed to calculate BMI. Please enter your height in centimetres.",
"vitals_height_label":        "Height (cm)",
"vitals_height_save":         "Save",
"vitals_height_success":      "Height updated successfully",
"vitals_height_error":        "Please enter a valid height between 50 and 250 cm",
"vitals_height_save_error":   "Could not save height. Please try again.",
"vitals_add_weight":          "Add Weight",
"vitals_add_measurement":     "Add Measurement",
"vitals_weight_chart":        "Weight History",
"vitals_bmi_chart":           "BMI History",
"vitals_waist_chart":         "Waist History",
"vitals_no_chart_data":       "No data available",
"vitals_date":                "Date",
"vitals_prefilled":           "Pre-filled from last record",
"vitals_save_success":        "Saved successfully",
"vitals_unit":                "unit",
"vitals_status_high":         "HIGH",
"vitals_status_low":          "LOW",
"vitals_chart_target":        "Target",
"vitals_fill_all_fields":     "Please fill in all fields.",
"vitals_save_error_generic":  "Could not save. Please try again.",

"vitals_info_title":      "Body Essentials – BMI and Waist Circumference",
"vitals_info_intro":      "Today, there are two methods of self-assessment that can give you a clearer picture of how your weight may be affecting your health – measuring your waistline and calculating your Body Mass Index (BMI). Body mass index (BMI) is a measure of body fat based on height and weight that applies to adult men and women. Calculate your BMI yourself: divide your weight in kilograms by the square of your height in metres.",
"vitals_info_bmi_heading": "What is important about BMI?",
"vitals_info_bmi_body":   "BMI (Body Mass Index) is a useful measure of overweight and obesity. It is calculated from your height and weight. The higher your BMI, the higher your risk for certain diseases such as heart disease, high blood pressure, type-2 diabetes, gallstones, breathing problems, and even certain cancers. A healthy BMI score is between 18.5 – 25, a BMI score above 30 is regarded as obesity with high disease risk. It makes sense to include your waist circumference when assessing your weight and health risk. Along with being overweight or obese, the following conditions will put you at greater risk for heart disease and other conditions: high blood pressure (hypertension), high LDL cholesterol (bad cholesterol), low HDL cholesterol (good cholesterol), high triglycerides, high blood glucose (sugar), family history of premature heart disease, physical inactivity, cigarette smoking. The good news is even a small weight loss (between 5 and 10 percent of your current weight) will help lower your risk of developing those diseases.",
"vitals_info_wc_heading":  "Why is my waist circumference (WC) important?",
"vitals_info_wc_body":    "Waist circumference (WC) is a measurement used to estimate abdominal subcutaneous and visceral fat stores. Higher values of WC (greater than 102 cm for men and greater than 88 cm for women) are associated with an increased risk for type 2 diabetes, high blood cholesterol, high blood pressure, and heart disease. A number of factors are associated with the variation in visceral adipose tissue distribution, including body mass index (BMI), age, sex, and race and ethnicity.",
"vitals_info_apple_pear":  "Are you an apple or a pear? Where you carry your weight is just as important as how much weight you carry when it comes to your health.",
"vitals_info_source":      "Source",

"vitals_bp_7day_avg":      "7-day average",
"vitals_bp_systole":       "Systole",
"vitals_bp_diastole":      "Diastole",
"vitals_bp_time_of_day":   "Time of day",
"vitals_bp_morning":       "Morning",
"vitals_bp_noon":          "Noon",
"vitals_bp_evening":       "Evening",
"vitals_bp_chart_title":   "Blood Pressure History",
"vitals_bp_add_title":     "Add Blood Pressure",
"vitals_bp_chart_sys":     "Systolic",
"vitals_bp_chart_dia":     "Diastolic",
"vitals_bp_col_time":      "Time",
"vitals_bp_info_title":    "Why is blood pressure so important?",
"vitals_bp_info_p1":       "Blood pressure is the force exerted against arterial walls as the heart pumps blood. High blood pressure stretches arteries beyond a healthy limit.",
"vitals_bp_info_p2":       "High blood pressure affects the majority of people, especially adults over the age of 65. Chronic overstretching of arteries has many negative effects like tears and scarring, weak spots that rupture easily, blood clot formation, increased workload on the heart, plaque build-up.",
"vitals_bp_info_ht":       "Hypertension Risks",
"vitals_bp_info_p3":       "High blood pressure increases your risk for stroke, heart attack or heart failure. Normal systolic blood pressure is below 120 mmHg, normal diastolic blood pressure is below 80 mmHg. Hypertension stage 2 with high risk is above 140/90 mmHg.",
"vitals_bp_info_p4":       "Diet and lifestyle changes can reduce your blood pressure. Eat lots of vegetables, fruit and whole grains, lean protein, low-fat dairy and nuts. Limit saturated fat, added sugar and junk food. Increase potassium and decrease sodium (less than 2300 mg/day). Supplement with vitamin C (500 mg/day).",
"vitals_bp_info_source":   "(Source: Linus Pauling Institute)",
"vitals_bp_status_elevated": "ELEVATED",
"vitals_bp_7day_count":      "Measurements in last 7 days",
"vitals_ref":                "Reference",

// ── USER ADMIN — Profile & Password ──────────────────────────
"ua_profile_headline":       "ACCOUNT SETTINGS",
"ua_profile_subtext":        "Update your personal information. Changing your email will require re-verification.",
"ua_profile_first_name":     "First Name",
"ua_profile_last_name":      "Last Name",
"ua_profile_username":       "Username",
"ua_profile_email":          "Email Address",
"ua_profile_phone":          "Phone Number",
"ua_profile_phone_ph":       "+436641234567",
"ua_profile_language":       "Language",
"ua_profile_height":         "Height (cm)",
"ua_profile_save":           "Save Changes",
"ua_profile_load_error":     "Failed to load profile.",
"ua_profile_update_error":   "Update failed. Please try again.",
"ua_profile_success":        "Profile updated successfully.",
"ua_female_headline":        "FEMALE HEALTH PROFILE",
"ua_female_subtext":         "Your hormonal profile helps us apply the correct reference ranges for your lab results. Please select the status that best describes your current hormonal context.",
"ua_female_profile_label":   "Hormonal Profile",
"ua_female_opt_cycletracker":    "Active Menstrual Cycle",
"ua_female_opt_perimenopause":   "Perimenopause",
"ua_female_opt_postmenopause":   "Postmenopause",
"ua_female_opt_birthcontrol":    "Hormonal Birth Control",
"ua_female_status_label":        "Hormonal Status",
"ua_female_status_normal":       "Normal",
"ua_female_status_hormonal_birth_control": "Hormonal Birth Control",
"ua_female_status_hrt":          "Hormone Replacement Therapy (HRT)",
"ua_female_save":            "Save Profile",
"ua_female_load_error":      "Failed to load female health profile.",
"ua_female_update_error":    "Failed to save. Please try again.",
"ua_female_success":         "Female health profile saved successfully.",
"ua_pw_headline":            "PASSWORD - ",
"ua_pw_subtext":             "CHANGE",
"ua_pw_dash_header":         "CHANGE PASSWORD",
"ua_pw_dash_subline":        "This section helps you change your password. Your new password will take effect at your next sign-in. Strong passwords keep your account safer — change them regularly. A strong password is long, random (a mix of upper and lower-case letters, numbers, and symbols) and unique. Passwords must be at least 8 characters and include at least one uppercase letter, one lowercase letter, one number, and one special character.",
"ua_pw_dash_subline_gen":    "Use the password generator (wand icon) to create a strong password automatically — copy it to your clipboard or apply it directly to the fields with the arrow button.",
"ua_pw_dash_subline_sec":    "Changing your password regularly is one of the most effective habits for protecting your account. Even if your credentials have been exposed in a data breach without your knowledge, a recent password change limits the window of risk. We recommend updating your password every 3 to 6 months.",
"ua_pw_new":                 "New Password",
"ua_pw_new_repeat":          "Repeat New Password",
"ua_pw_old":                 "Old Password",
"ua_pw_submit":              "Submit",
"ua_pw_gen_suggest":         "Suggest a strong password",
"ua_pw_gen_copy":            "Copy",
"ua_pw_gen_apply":           "Apply to fields",
"ua_pw_gen_copied":          "Copied!",
"ua_pw_success":             "Your password has been changed successfully",
"ua_pw_error":               "Please check your input.",

"addon_purchases_headline":  "ADD-ON PURCHASES",
"addon_subtext":             "Below you find all your add-on purchases you selected for your lab visits. The add-on purchases are grouped by the date of payment and record creation. For all add-on purchases you also received an email with a summary of your add-on selections together with a download link for the invoice.",
"addon_selected_for":        "Selected Add-Ons —",
"addon_hide":                "Hide",
"addon_view":                "View",
"addon_orders_label":        "Add-Ons",
"addon_status_paid":         "Paid",
"addon_status_unpaid":       "Unpaid",
"addon_total_vat":           "Total Add-Ons incl. 20% VAT",
"addon_invoice":             "Invoice",
"addon_no_purchases":        "No add-on purchases yet.",
"addon_fetch_error":         "Failed to load add-on purchases.",

"sub_headline":              "MEMBERSHIP",
"sub_subtext":               "In this section you find detailed information about your current subscription plan. Subscription is renewed every year automatically. You can upgrade, downgrade, cancel and resume your plan according to the terms of service.",
"sub_manage_headline":       "MANAGE MEMBERSHIP",
"sub_change_subtext":        "You can change your subscription plan — upgrade, downgrade, cancel or resume — according to the terms of service.",
"sub_status_active":         "Active",
"sub_status_inactive":       "Inactive",
"sub_billing_period":        "Billing period",
"sub_price":                 "Price",
"sub_per_year":              "/ year",
"sub_cancels_at_period_end": "Cancels at period end",
"sub_change_plan":           "Change plan",
"sub_cancel":                "Cancel subscription",
"sub_resume":                "Resume subscription",
"sub_change_plan_dialog":    "Change subscription plan",
"sub_confirm_change":        "Confirm change",
"sub_fetch_error":           "Failed to load subscription data.",
"sub_action_error":          "Action failed. Please try again.",
"sub_plan_change_error":     "Failed to change plan. Please try again.",
"sub_no_plan":               "You don't have an active subscription plan.",
"sub_proration_notice":      "Changing plans takes effect immediately. Stripe will prorate the difference, which may charge or credit your payment method right away.",
"sub_plan2_name":            "Membership - Test 2x / year, billed annually",
"sub_plan3_name":            "Membership - Test 4x / year, billed annually",
"sub_plan4_name":            "Membership - Test 2x / year, billed monthly",
"sub_plan5_name":            "Membership - Test 4x / year, billed monthly",

"invoices_headline":             "INVOICES",
"invoices_subtext":              "Here you find all invoices for your subscription and add-on purchases.",
"invoices_empty":                "No invoices yet.",
"invoices_view":                 "View",
"invoices_download":             "Download",
"invoices_load_more":            "Load more",
"invoices_status_paid":          "Paid",
"invoices_status_open":          "Open",
"invoices_status_void":          "Void",
"invoices_status_uncollectible": "Uncollectible",
"invoices_status_draft":         "Draft",
"invoices_type_subscription":    "Subscription",
"invoices_type_addon":           "Add-On",
"invoices_fetch_error":          "Failed to load invoices.",

"pay_headline":              "CHANGE PAYMENT METHOD",
"pay_subtext":               "You can change your default payment method here. In most cases you will renew your credit card in time before they expire.",
"pay_current_method":        "Current Payment Method",
"pay_card_fallback":         "Card",
"pay_exp":                   "Exp",
"pay_status_active":         "Active",
"pay_status_error":          "Error",
"pay_no_method":             "No payment method on file",
"pay_change_card":           "Change Card",
"pay_update_method_dialog":  "Update Payment Method",
"pay_update_card":           "Update Card",
"pay_update_error":          "Error updating card. Please try again.",

// ── GUIDED TOUR ──────────────────────────────────────────────────────────────
'tour_welcome_title':     'Welcome to your Health Cockpit!',
'tour_welcome_body1':     'Medically reviewed, scientifically prepared — so you truly understand your body, not just its numbers.',
'tour_welcome_body2':     'In the next few minutes we will guide you step by step through what you\'ll find where — and what your values mean for your health.',
'tour_welcome_cta':       'Start tour',
'tour_welcome_skip':      'Skip',

'tour_closing_title':     'You now know your Cockpit!',
'tour_closing_body':      'Start with your first recommendation — start small, stay consistent. Your body will thank you.',
'tour_closing_brand1':    'We built speak23 because we believe: those who truly understand their body can make the best decisions for their health. Take time to understand your data — you yourself are the most important part of it.',
'tour_closing_brand2':    'The future of medicine lies in prevention. And you just took the first step.',
'tour_closing_hint':      'Restart this tour at any time — via the ? in the sidebar.',
'tour_closing_cta':       'To the Cockpit →',

'tour_step_nav_title':    'Opening & closing the navigation',
'tour_step_nav_body':     'This button in the top left next to the logo opens and closes the navigation menu. Use it to reach all areas of the speak23 software.',
'tour_step_sections_title':  'The 4 sections of the navigation',
'tour_step_sections_body':   'The navigation menu is divided into 4 sections:',
'tour_step_sections_item1':  'Control your health – Cockpit, recommendations, doctor visit and biological age',
'tour_step_sections_item2':  'Test results – all lab values and detailed analyses',
'tour_step_sections_item3':  'More apps for your health – Body, cycle, medication',
'tour_step_sections_item4':  'Administration – Lab visits, subscription and account settings',
'tour_step0_title':       'The 12 mechanisms of your health',
'tour_step0_body':        'Your body is examined in four areas: Metabolism, Immune System, Organs and Micronutrients. For each area the cockpit shows you the most important mechanisms — so you can see at a glance how you are currently doing there.',
'tour_step1_title':       'How to read your risk points',
'tour_step1_body':        'The points next to each term show your personal risk value. Few green points mean: no action needed. The more points are filled in — especially in orange — the more this area deserves your attention. Use the arrow to open the analysis created for you for each mechanism.',
'tour_step2_title':       'Your personal recommendations',
'tour_step2_highlight':   'Start with your first recommendation — it has the highest priority and the greatest leverage for your health.',
'tour_step2_body':        'Your recommendations have their own page in the navigation. Try to focus on exactly this one thing until your next test. Start small and stay consistent — that makes the difference.',
'tour_step3_title':       'Talk to your doctor',
'tour_step3_body':        'You can reach this page through the navigation as well. Here you\'ll find ready-made questions for your next doctor\'s appointment — derived directly from your lab values. This way you go well prepared to the conversation and know exactly what is worth discussing.',
'tour_step5_title':       'Your add-on analyses',
'tour_step5_body':        'If you have booked hormones, omega or gut microbiome as an add-on, you\'ll find your personal results here.',
'tour_step5_highlight':   'For women who want to track their cycle: make sure to keep your cycle tracker up to date — only then will your lab values be interpreted in the correct cycle phase. This is the key to a truly personalized analysis, and something that unfortunately often gets lost in medicine.',
'tour_step7_title':       'All your lab values',
'tour_step7_body':        'Here you\'ll find every single value from your lab test — with reference range and status. You don\'t have to understand everything in detail: the cockpit has already prepared the most important things for you. If you want to dive deeper, everything is here.',
'tour_step8_title':       'Your biological age',
'tour_step8_body':        'Your biological age shows how old your body really is — independent of your date of birth.',
'tour_step8_highlight':   'Numerous strong scientific studies confirm: A low biological age is one of the strongest predictors for a longer life expectancy and more healthy years.',
'tour_step8_goal':        'Keep your biological age below your calendar age — or lower it if it is currently too high. Science confirms this clearly.',

'tour_btn_back':          '← Back',
'tour_btn_close':         'Close',
'tour_btn_last':          'Done',
'tour_btn_next':          'Next →',
'tour_btn_next_with_progress': 'Next ({current} of {total})',
'tour_btn_open':          'Open tour',
'tour_restart_label':     'Start tour',

// ── FEEDBACK ───────────────────────────────────────
'page_hl_feedback': 'FEEDBACK - ',
'page_sp_feedback': 'YOUR FEEDBACK',
'feedback_header': 'Your Feedback',
'feedback_subheader': 'Thank you for choosing speak23 and placing your trust in us! We are constantly trying to improve and expand the speak23 solution. Your feedback is therefore an important input for our further development.',
'feedback_answered_label': 'answered',
'feedback_submit': 'Submit Feedback',
'feedback_submitting': 'Submitting…',
'feedback_thank_you': 'Thank you for your feedback',
'feedback_already_title': 'You have already submitted your feedback. No more action required.',

// ── GIFT REDEMPTION ──────────────────────────────────────────
'gift_redeem_headline': 'You have received a gift',
'gift_redeem_from': 'From',
'gift_redeem_for': 'For',
'gift_redeem_valid_until': 'Redeem until',
'gift_redeem_button': 'Redeem gift',
'gift_redeem_not_found': 'This gift link is not valid. Please check the link in your email.',
'gift_redeem_load_error': 'The gift could not be loaded. Please try again later.',
'gift_redeem_already_redeemed': 'This gift has already been redeemed.',
'gift_redeem_not_payable': 'This gift is not available for redemption.',
'gift_redeem_expired': 'The redemption period for this gift has expired.',
'gift_redeem_error': 'The gift could not be redeemed. Please try again.',
'gift_redeem_auth_title': 'Redeem your gift in a few simple steps:',
'gift_redeem_step_1': 'Please create an account (“Register”)',
'gift_redeem_step_2': 'Log in with your credentials',
'gift_redeem_step_3': 'You will be guided through the onboarding (lab visit appointment, questionnaire)',
'gift_redeem_auth_closing': 'Good luck!',
'gift_redeem_register': 'Create account',
'gift_redeem_success_title': 'Gift redeemed',
'gift_redeem_success_text': 'Your speak23 access is active until',
'gift_redeem_continue': 'Continue',

};
